import { Expose } from "class-transformer";

export class OnboardingSignaturePreviewDto {
  @Expose()
  fullName: string | null;

  @Expose()
  dni: string | null;

  @Expose()
  date: string;
}
